/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {IsValid} from './IsValid';

export class Valid<T> implements IsValid<T> {
    constructor(
        public readonly entity: T
    ) {
    }

    public static of<T>(entity: T): Valid<T> {
        return new Valid(entity);
    }

    public isValid(): boolean {
        return true;
    }

    public toValid(): Valid<T> {
        return this;
    }
}
